import { Link } from "react-router-dom";

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  cover: string;
  author: string;
  publishDate: string;
  readTime: string;
  views: string;
  tags: string[];
}

export default function ArticleCard({ slug, title, excerpt, cover, author, publishDate, readTime, views, tags }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block">
        <div className="flex flex-col sm:flex-row">
          <div className="relative w-full sm:w-[240px] h-40 sm:h-auto flex-shrink-0 overflow-hidden">
            <img
              src={cover}
              alt={title}
              title={title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
          </div>
          <div className="p-4 flex flex-col justify-between flex-1">
            <div>
              <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 leading-snug mb-2">
                {title}
              </h3>
              <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                {excerpt}
              </p>
            </div>
            <div className="flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
              <span className="whitespace-nowrap">{author}</span>
              <span className="whitespace-nowrap">{publishDate}</span>
              <span className="whitespace-nowrap">{readTime}</span>
              <span className="whitespace-nowrap">{views} 阅读</span>
            </div>
            <div className="flex flex-wrap gap-1.5 mt-2">
              {tags.map((tag) => (
                <span key={tag} className="bg-secondary-100 text-secondary-900 text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}